(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nrz-product-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const findOrderTarget = () => {
      const forms = [...document.querySelectorAll('form')];
      const leadForm = forms.find((form) => form.querySelector('input[type="tel"], input[name*="phone" i], select[name*="wilaya" i]'));
      return leadForm || document.querySelector('[id^="ProductInformation-"]') || document.querySelector('main');
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.nrz-order-trigger');
      if (!trigger) return;
      const target = findOrderTarget();
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => {
        const field = target.querySelector('input:not([type="hidden"]), select, textarea');
        if (field) field.focus({ preventScroll: true });
      }, 500);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
